import React from 'react';
import { API_URL } from '../../../constants';
import resolveImage from '../../../components/store/ResolveImage';

const HomeBanner = (props) => {
  const media = props.media ? API_URL + props.media : "/uploads/videos/purple.mp4";

  const isVideo = (url) => {
    return ['.mp4', '.webm', '.mov'].some(ext => url.toLowerCase().endsWith(ext));
  };

  /*const getMimeType = (url) => {
    switch url:
    case '.mp4': return 'video/mp4';
    case '.webm': return 'video/webm';
    case '.mov': return 'video/quicktime';
    default: return 'video/mp4';
  };
  */

  return (
    <div className="homeBanner">
      <div className="videoContainer">
        {media && isVideo(media) ? (
          <video autoPlay muted playsInline loop>
            <source src={media} type={'video/mp4'} />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={resolveImage(API_URL + media)} className="bannerImage" alt="Home banner" />
        )}
      </div>
    </div>
  );
};

export default HomeBanner;
